export const SAMPLE_STATE = {
  UNMAKE_PATTERN: 1, // 待打版
  MAKING_PATTERN: 2,
  MADE_PATTERN: 3,
  MAKING_SAMPLE: 4,
  MADE_SAMPLE: 5,
  PURCHASING: 7,
  PURCHASED: 8,
  IN_STORAGE: 6
}

export const SAMPLE_STATE_TEXT = {
  [SAMPLE_STATE.UNMAKE_PATTERN]: '待打版',
  [SAMPLE_STATE.MAKING_PATTERN]: '打版中',
  [SAMPLE_STATE.MADE_PATTERN]: '已打版',
  [SAMPLE_STATE.MAKING_SAMPLE]: '打样中',
  [SAMPLE_STATE.MADE_SAMPLE]: '已打样',
  [SAMPLE_STATE.PURCHASING]: '采买中',
  [SAMPLE_STATE.PURCHASED]: '已采买',
  [SAMPLE_STATE.IN_STORAGE]: '已入库'
}
